const STORAGE_KEY = 'axetra_attribution';
const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export interface Attribution {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  ref?: string;
  landing_page?: string;
  referrer_url?: string;
}

// First-touch: once an attribution is stored, later page views never overwrite it.
export function captureAttribution(search: string): void {
  if (typeof window === 'undefined' || localStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(search);
  const ref = params.get('ref');
  if (!UTM_PARAMS.some((key) => params.has(key)) && !ref) return;

  const attribution: Attribution = {
    landing_page: window.location.pathname + search,
    referrer_url: document.referrer || undefined,
  };
  for (const key of UTM_PARAMS) {
    const value = params.get(key);
    if (value) attribution[key] = value;
  }
  if (ref) attribution.ref = ref;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
}

export function getStoredAttribution(): Attribution | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Attribution;
  } catch {
    return null;
  }
}
